module.exports = __webpack_public_path__ + "img/1.24_Russian_road_sign.c2ea5771.svg";